export default __webpack_public_path__ + "static/media/thum1.5fa837e9.jpg";